import { useState } from "react";
import { BadgeCheck } from "lucide-react";
import { Shell, Head, Field, Btn, Alert } from "../../components/ui/AuthComponents";
import { useAuth } from "../../hooks/useAuth";

export default function ValetLogin({ onBack, onSuccess }) {
  const { loginValet } = useAuth();

  const [code, setCode]         = useState("");
  const [err, setErr]           = useState("");
  const [loading, setLoading]   = useState(false);
  const [apiError, setApiError] = useState("");

  const submit = async () => {
    if (!code.trim())           { setErr("Valet code required"); return; }
    if (code.trim().length < 4) { setErr("Code must be ≥ 4 characters"); return; }

    setErr("");
    setApiError("");
    setLoading(true);

    const result = await loginValet({ code });

    setLoading(false);

    if (result.error) {
      setApiError(result.error);
    } else {
      onSuccess("valet");
    }
  };

  const handleKeyDown = (e) => { if (e.key === "Enter") submit(); };

  return (
    <Shell role="valet" onBack={onBack}>
      <Head
        eyebrow="Valet Crew"
        ec="#e65100"
        title="Enter your access code"
        sub="Provided by your HOA or office administrator"
      />
      <div style={{ display: "flex", flexDirection: "column", gap: 15 }}>

        {apiError && (
          <div className="fu">
            <Alert type="warn">{apiError}</Alert>
          </div>
        )}

        <Field
          label="Valet Access Code"
          value={code}
          onChange={v => { setCode(v); setErr(""); setApiError(""); }}
          placeholder="Enter your assigned code"
          icon={BadgeCheck}
          error={err}
          autoFocus
          delay="d1"
          maxLength={24}
          onKeyDown={handleKeyDown}
        />

        <div className="fu d2">
          <Alert type="info">
            No account sign-up needed. Your access code was issued by your administrator.
          </Alert>
        </div>

        <div className="fu d3" style={{ marginTop: 4 }}>
          <Btn label="Continue →" loading={loading} onClick={submit} />
        </div>
      </div>
    </Shell>
  );
}